import {TenderSelection} from '@frontend/shared-api';

export interface SelectionOption {
  label: string;
  value: TenderSelection | null;
}

export const SELECTION_OPTION_KEYS: readonly {labelKey: string; value: TenderSelection | null}[] = [
  {
    labelKey: 'project.steps.invitationList.selection.participant',
    value: TenderSelection.PARTICIPANT,
  },
  {
    labelKey: 'project.steps.invitationList.selection.waitingList',
    value: TenderSelection.WAITING_LIST,
  },
  {labelKey: 'project.steps.invitationList.selection.notRelevant', value: null},
];
